import React, { useState } from 'react';
import { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Text } from '@cuemath/web-comps';
import { Popup } from 'semantic-ui-react';
import { COLORS } from '@cuemath/comps';

import CopyIcon from 'img/copy.svg';
import CheckIcon from 'img/check-large.svg';
import { copyToClipboard } from 'utils';
import { BorderedBox } from 'screens/student-details/styled-comps';

const CopyButtonImage = styled.img`
  cursor: pointer;
`;

const ID = styled(Text)`
  overflow-wrap: anywhere;
  flex: 1;
  ${({ customTextStyle }) =>
    customTextStyle &&
    css`
      max-width: 107px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `};
`;

export default function CopyButton({
  text,
  copyMessage,
  marginTop,
  padding,
  customTextStyle,
  onClick,
  style = {}
}) {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 3000);
    }
  }, [isCopied]);

  function copy() {
    copyToClipboard(text);
    setIsCopied(true);
  }

  return (
    <BorderedBox
      style={{ ...style, background: 'rgba(246,246,246,0.8)', gap: 8 }}
      justifyContent="space-between"
      alignItems="center"
      marginTop={marginTop}
      padding={padding}
    >
      <ID
        color={COLORS.COLA_LIGHTER}
        variant="body3"
        customTextStyle={customTextStyle}
        onClick={onClick}
      >
        {text}
      </ID>
      <Popup
        trigger={<CopyButtonImage onClick={copy} src={isCopied ? CheckIcon : CopyIcon} />}
        content={!isCopied ? copyMessage : 'Copied'}
        size="mini"
        position="bottom right"
        inverted
      />
    </BorderedBox>
  );
}
